<template>
  <div class="detail-panel" v-if="showDetail">
    <div class="head">
      <div>详情</div>
      <i @click="close" class="iconfont icon-close"></i>
    </div>
    <div class="title van-ellipsis" v-if="eventInfo">
      {{ eventInfo.eventName }}
    </div>
    <div class="user" v-if="eventInfo">
      <div class="avatar">
        <img v-if="eventInfo.userFace" :src="$isCdn(eventInfo.userFace)" alt="" />
        <img v-else :src="avatar" alt="" />
      </div>
      <div class="info">
        <div v-if="eventInfo.eventTalkManName" class="name">{{ eventInfo.eventTalkManName }}</div>
        <div v-else class="name">管理员</div>
        <div class="org van-ellipsis">{{ eventInfo.orgName }}</div>
      </div>
      <div class="notice" v-if="!isAuth && eventInfo && eventInfo.eventTalkManName">
        <div class="attention" @click="handleAttention(1)" v-if="!eventInfo.follow">+ 关注</div>
        <div class="attention" @click="handleAttention(2)" v-else>+ 取消关注</div>
      </div>
    </div>
    <div class="section" v-if="eventInfo">
      <div class="section-left">时间</div>
      <div class="section-right" v-if="eventInfo.eventType === '7'">
        {{ eventInfo.eventStartTime | formatDate('yyyy-MM-dd hh:mm') }} -
        {{ eventInfo.eventEndTime | formatDate('yyyy-MM-dd hh:mm') }}
      </div>
      <div class="section-right" v-else>
        {{ eventInfo.eventStartTime | formatDate('yyyy-MM-dd hh:mm') }} -
        {{ eventInfo.eventEndTime | formatDate('hh:mm') }}
      </div>
    </div>
    <div class="section" v-if="eventInfo">
      <div class="section-left">活动</div>
      <div class="section-right">{{ activityTypeText() }}</div>
    </div>
    <div class="section" v-if="eventInfo.eventType === '2'">
      <div class="section-left">代码</div>
      <div class="section-right">{{ eventInfo.eventCode }}</div>
    </div>
    <div class="section" v-if="otherInfo && otherInfo.roomName">
      <div class="section-left">教室</div>
      <div class="section-right">{{ otherInfo.roomName }}</div>
    </div>
    <div class="section" v-if="otherInfo && otherInfo.stageName && otherInfo.gradeName && otherInfo.subjectName">
      <div class="section-left">科目</div>
      <div class="section-right">
        {{ otherInfo.stageName }}
        {{ otherInfo.gradeName }}
        {{ otherInfo.subjectName }}
      </div>
    </div>
    <div class="section" v-if="otherInfo && otherInfo.versionName && otherInfo.catalogName">
      <div class="section-left">课程</div>
      <div class="section-right">
        {{ otherInfo.versionName }}
        {{ otherInfo.catalogName }}
      </div>
    </div>
    <div class="section" v-if="load && activeInfo.labelDataVoList.length">
      <div class="section-left">标签</div>
      <div class="section-right label">
        <span class="van-ellipsis" v-for="item in activeInfo.labelDataVoList" :key="item.id">{{ item.name }}</span>
      </div>
    </div>
    <div class="section" v-if="load && eventInfo.mask">
      <div class="section-left">简介</div>
      <div class="section-right">
        {{ eventInfo.mask }}
      </div>
    </div>
  </div>
</template>

<script>
import {fallowUser} from '@/api'
export default {
  data() {
    return {
      id: this.$route.params.id,
      avatar: require('@/assets/image/avatar.svg')
    }
  },
  computed: {
    showDetail() {
      return this.$store.state.activePlay.panel.showDetail
    },

    activeInfo() {
      return this.$store.state.activePlay.activeInfo
    },
    isAuth() {
      if (this.activeInfo) {
        return this.activeInfo.eventInfo.eventTalkUserId === this.$store.state.userInfo.id
      }
      return false
    },

    load() {
      return this.activeInfo && this.activeInfo.eventInfo
    },
    eventInfo() {
      if (this.activeInfo) {
        return this.activeInfo.eventInfo
      }
      return null
    },
    otherInfo() {
      if (this.activeInfo) {
        return this.activeInfo.eventOtherInfo
      }
      return null
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  methods: {
    close() {
      this.$store.commit('controlPanel', {showDetail: false})
    },
    handleAttention(type) {
      console.log('this.userInfo.id', this.userInfo.id)
      if (!this.userInfo.id) {
        return this.$dialog
          .alert({
            closeOnClickOverlay: true,
            theme: 'round-button',
            confirmButtonColor: '#4465f3',
            message: '您没有登录,去登录?'
          })
          .then(() => {
            this.$router.replace(`/login?redirect=${encodeURIComponent(location.href)}`)
          })
      }
      fallowUser(this.activeInfo.eventInfo.eventTalkUserId, type).then(res => {
        this.$Toast.success('成功')
        this.$store.dispatch('getActiveInfo', this.id)
      })
    },
    activityTypeText() {
      const key = this.activeInfo.eventInfo.eventType
      switch (key) {
        case '1':
          return '录播课堂'
        case '2':
          return '同步课堂'
        case '3':
          return '视频会议'
        case '4':
          return '直播教研'
        case '5':
          return '互动教研'
        case '6':
          return '直播教学'
        case '7':
          return '直播'
        default:
          return '自定义活动'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.detail-panel {
  overflow-y: scroll;
  position: absolute;
  z-index: 101;
  top: 220px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  padding: 10px;
}
.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  font-weight: bold;
  padding: 15px 0;
}
.user {
  background: #f4f6f9;
  padding: 15px 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  .avatar {
    width: 48px;
    height: 48px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .info {
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex: 1;
    width: 0;
    .name {
      font-weight: bold;
    }
    .org {
      font-size: 12px;
    }
  }
  .notice {
    .attention {
      font-size: 12px;
      background: rgba(68, 101, 243, 0.16);
      color: rgba(68, 101, 243, 1);
      border-radius: 8px;
      padding: 4px 8px;
    }
  }
}

.section {
  margin-top: 20px;
  .section-left {
    position: absolute;
    color: #909399;
    font-size: 14px;
  }
  .section-right {
    margin-left: 50px;
    color: #303133;
    font-size: 14px;
    word-wrap: break-word;
  }
  .section-right.label span {
    display: inline-block;
    height: 28px;
    background: #f4f6f9;
    border-radius: 8px;
    color: #606266;
    line-height: 28px;
    padding: 0 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    max-width: 100%;
  }
}
</style>
